export const ADD_PRODUCT = "product/addProduct";
export const DECREASE_PRODUCT_QUANTITY = "product/decreaseProductQuantity";
export const INCREASE_PRODUCT_QUANTITY = "product/increaseProductQuantity";
export const RETURN_QTY_AFTER_CART_DLT = "product/returnQtyAfterCartDlt";
